import axios from '../utils/axios';

export default function postCompetitionEmail(adminId, data) {
    
    return (
        axios.post('/admin/'+adminId + '/competition/user/admin/competition-mail-request', data)
    )
}
